/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function BannerField (props: FormTextFieldProps) {
  const { name = 'banner', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'banner',
        defaultMessage: 'Bannière'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default BannerField
